<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />
      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <div
            id="DirectoryList"
            class="row"
          >
            <div class="col-xl-12">
              <div
                id="DirectoryPortlet"
                class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
                :m-portlet="'true'"
              >
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                        <i class="flaticon-signs-1 m--font-brand m--icon-font-size-lg1 mt-n1" />
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{ $t( 'Directory.manage' ) }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="m-portlet__body">
                  <div class="table_sticky-header">
                    <table
                      id="tableDirectories"
                      class="table m-table m-table--head-no-border table table-striped"
                    >
                      <thead>
                        <tr>
                          <th
                            style="width:60px;"
                            class="text-center"
                          >
                            <i class="flaticon-eye" />
                          </th>
                          <th
                            style="width:55px"
                            class="text-left"
                          />
                          <th
                            style="width:200px"
                            class="text-left"
                          >
                            {{ $t( 'Directory.table.Id' ) }} / {{ $t( 'Directory.table.Name' ) }}
                          </th>
                          <th
                            style="width:180px"
                            class="text-left"
                          >
                            {{ $t( 'Directory.table.type' ) }}
                          </th>
                          <th
                            style="width:180px"
                            class="text-left"
                          >
                            {{ $t( 'common.Activated' ) }}
                          </th>
                          <th
                            style="width:100px"
                            class="text-center"
                          >
                            {{ $t( 'Directory.table.actions' ) }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(directoryItem, index) in directories"
                          :key="directoryItem[index]"
                          :class="{'m-table__row':true}"
                          data-offlinetxt="offline directory"
                        >
                          <td class="align-middle text-center m--hidden-mobile m--hidden-tablet">
                            <a
                              :href="getRedirectURL(directoryItem.id)"
                              target="_blank"
                            >
                              <i class="flaticon-eye" />
                            </a>
                          </td>
                          <td
                            class="position-relative align-middle"
                            data-thead-name=""
                            style="display: table-cell; table-layout: fixed; text-align: center;"
                          >
                            <div
                              v-if="directoryItem.logo"
                              class="thumbnailTable align-middle"
                              style="display: table-cell; text-align: center; width:100%; height:100%;"
                            >
                              <img
                                :src="getLogoURL( directoryItem )"
                                style="width: 100%; height: auto;"
                              >
                            </div>
                            <div
                              v-else
                              class="d-inline-block"
                            >
                              <span class="img-cont no-logo align-middle">
                                <i class="la la-camera m--icon-font-size-lg3 d-block" />
                                <span class="d-block small text-center">{{ $t( 'common.nologo' ) }}</span>
                              </span>
                            </div>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t( 'Directory.table.Id' )+' / '+ $t( 'Directory.table.Name' )"
                          >
                            {{ directoryItem.id }}
                            <template v-if="directoryItem.name">
                              <br>
                              {{ directoryItem.name }}
                            </template>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t( 'Directory.table.featured' )"
                          >
                            <template v-if="directoryItem.adInfo.isFeaturedPremium">
                              {{ $t( 'Directory.serviceTypes.pro' ) }}
                            </template>
                            <template v-else-if="directoryItem.adInfo.isFeatured">
                              {{ $t( 'Directory.serviceTypes.basicplus' ) }}
                            </template>
                            <template v-else>
                              {{ $t( 'Directory.serviceTypes.basic' ) }}
                            </template>
                          </td>
                          <td class="align-middle">
                            <template v-if="directoryItem.active">
                              {{ $t( 'common.Yes' ) }}
                            </template>
                            <template v-else>
                              <span class="text-danger font-weight-bold">{{ $t( 'common.No' ) }}</span>
                            </template>
                          </td>
                          <td class="align-middle text-left position-relative">
                            <button
                              type="button"
                              class="btn btn-outline-brand m-btn btn-block m-btn--wide btn-sm"
                              @click="editDirectory(directoryItem)"
                            >
                              {{ $t( 'common.Edit' ) }}
                            </button>
                            <router-link
                              v-if="!directoryItem.adInfo.isFeatured && !directoryItem.adInfo.isFeaturedPremium && directoryItem.active"
                              :to="{ name: 'AdvertiseDir'}"
                              class="btn btn-success m-btn btn-block m-btn--wide btn-sm"
                            >
                              {{ $t( 'Directory.table.UpgradeToBasicPlus' ) }}
                            </router-link>
                            <router-link
                              v-if="!directoryItem.adInfo.isFeaturedPremium && directoryItem.active"
                              :to="{ name: 'AdvertiseDir'}"
                              class="btn btn-info m-btn btn-block m-btn--wide btn-sm"
                            >
                              {{ $t( 'Directory.table.UpgradeToPro' ) }}
                            </router-link>
                            <template v-if="directoryItem.active">
                              <button
                                type="button"
                                class="btn btn-warning m-btn btn-block m-btn--wide btn-sm"
                                @click="deactivateDirectory(directoryItem)"
                              >
                                {{ $t( 'common.Deactivate' ) }}
                              </button>
                            </template>
                            <template v-else>
                              <button
                                type="button"
                                class="btn btn-warning m-btn btn-block m-btn--wide btn-sm font-weight-bold"
                                @click="activateDirectory(directoryItem)"
                              >
                                {{ $t( 'common.Activate' ) }}
                              </button>
                            </template>
                          </td>
                        </tr>
                        <template v-if="directories.length === 0">
                          <tr>
                            <td
                              colspan="11"
                              class="text-center m--regular-font-size-lg3"
                            >
                              <template v-if="!loading">
                                <button
                                  type="button"
                                  class="btn btn-brand"
                                  @click="createListing"
                                >
                                  {{ $t( 'Directory.createListing' ) }}
                                </button>
                              </template>
                              <template v-else>
                                {{ $t( 'common.sendingDataPleaseWait' ) }}
                              </template>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                    <button
                      type="button"
                      class="btn btn-link p-0"
                      @click="loadDirectories"
                    >
                      {{ $t( 'Directory.form.Refresh' ) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="modalDirectoryEdit"
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modalDirectoryEdit"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div
              class="modal-dialog modal-xl m-portlet--fullscreen"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <template v-if="directory.id">
                    <h5 class="modal-title">
                      {{ $t( 'common.Edit' ) }} {{ directory.name }}
                    </h5>
                  </template>
                  <template v-else>
                    {{ $t( 'Directory.form.CreateListing' ) }}
                  </template>
                  <button
                    type="button"
                    class="close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-xl-12">
                      <div
                        id="m_wizard"
                        class="m-wizard m-wizard--5 m-wizard--brand m-wizard--step-first"
                        :data-startStep="startTab"
                      >
                        <div class="m-wizard__head">
                          <div class="row">
                            <div class="col-xl-12">
                              <div class="m-wizard__nav">
                                <div class="m-wizard__steps">
                                  <div
                                    :class="{'m-wizard__step m-wizard__step--current':true,'border-danger':stepOneHasErrors}"
                                    :m-wizard-target="'m_wizard_form_step_1'"
                                  >
                                    <div
                                      :class="{'m-wizard__step-info text-center':true,'text-danger':stepOneHasErrors}"
                                    >
                                      <button
                                        type="button"
                                        :class="{'btn btn-link m-wizard__step-number':true}"
                                        @click="clickEditTab(1)"
                                      >
                                        <span :class="{'m-wizard__step-seq m--hidden-mobile':true,'text-danger':stepOneHasErrors, 'font-weight-bold': (step === 1 )}">
                                          1.
                                        </span>
                                        <span :class="{'m-wizard__step-label': true, 'text-danger': stepOneHasErrors, 'font-weight-bold': (step === 1 )}">
                                          {{ $t( 'common.Details' ) }}
                                        </span>
                                      </button>
                                      <small v-show="stepOneHasErrors">{{ $t( 'Directory.form.HasErrors') }}</small>
                                    </div>
                                  </div>
                                  <div
                                    :class="{'m-wizard__step':true,'border-danger':stepTwoHasErrors}"
                                    :m-wizard-target="'m_wizard_form_step_2'"
                                  >
                                    <div
                                      :class="{'m-wizard__step-info text-center':true,'text-danger':stepTwoHasErrors}"
                                    >
                                      <button
                                        type="button"
                                        class="btn btn-link m-wizard__step-number"
                                        :disabled="stepOneHasErrors"
                                        @click="clickEditTab(2)"
                                      >
                                        <span :class="{'m-wizard__step-seq m--hidden-mobile':true,'text-danger':stepTwoHasErrors, 'font-weight-bold': (step === 2 )}">
                                          2.
                                        </span>
                                        <span :class="{'m-wizard__step-label': true, 'text-danger': stepTwoHasErrors, 'font-weight-bold': (step === 2 )}">
                                          {{ $t( 'Directory.form.AboutUs' ) }}
                                        </span>
                                      </button>
                                      <small v-show="stepTwoHasErrors">{{ $t( 'Directory.form.HasErrors') }}</small>
                                    </div>
                                  </div>
                                  <div
                                    :class="{'m-wizard__step':true,'border-danger':stepThreeHasErrors}"
                                    :m-wizard-target="'m_wizard_form_step_3'"
                                  >
                                    <div
                                      :class="{'m-wizard__step-info text-center':true,'text-danger border-danger':stepThreeHasErrors}"
                                    >
                                      <button
                                        type="button"
                                        class="btn btn-link m-wizard__step-number"
                                        :disabled="stepOneHasErrors || stepTwoHasErrors"
                                        @click="clickEditTab(3)"
                                      >
                                        <span :class="{'m-wizard__step-seq m--hidden-mobile':true,'text-danger':stepThreeHasErrors, 'font-weight-bold': (step === 3 )}">
                                          3.
                                        </span>
                                        <span :class="{'m-wizard__step-label': true, 'text-danger': stepThreeHasErrors, 'font-weight-bold': (step === 3 )}">
                                          {{ $t( 'Directory.form.Logo' ) }}
                                        </span>
                                      </button>
                                      <small v-show="stepThreeHasErrors">{{ $t( 'Directory.form.HasErrors') }}</small>
                                    </div>
                                  </div>
                                  <div
                                    class="m-wizard__step"
                                    :m-wizard-target="'m_wizard_form_step_4'"
                                  >
                                    <div class="m-wizard__step-info text-center">
                                      <button
                                        type="button"
                                        class="btn btn-link m-wizard__step-number"
                                        :disabled="stepOneHasErrors || stepTwoHasErrors || stepThreeHasErrors"
                                        @click="clickEditTab(4)"
                                      >
                                        <span :class="{'m-wizard__step-seq m--hidden-mobile': true, 'font-weight-bold': (step === 4 )}">
                                          4.
                                        </span>
                                        <span :class="{'m-wizard__step-label':true, 'font-weight-bold': (step === 4 )}">
                                          {{ $t( 'common.Confirmation' ) }}
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="m-wizard__form">
                          <form
                            id="m_form"
                            class="m-form m-form--label-align-left- m-form--state-"
                            novalidate="novalidate"
                          >
                            <div
                              class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-danger fade show mt-4 mb-1"
                              role="alert"
                            >
                              <div class="m-alert__icon">
                                <i class="flaticon-danger" />
                                <span />
                              </div>
                              <div class="m-alert__text">
                                <strong>{{ $t( 'Directory.form.Attention' ) }}:</strong> {{ $t( 'Directory.form.ChangesSavedOnFinalStep' ) }}
                              </div>
                            </div>
                            <div class="m-portlet__body">
                              <div
                                id="m_wizard_form_step_1"
                                class="m-wizard__form-step m-wizard__form-step--current"
                              >
                                <div class="row">
                                  <div class="col-xl-12">
                                    <div class="m-form__section m-form__section--first">
                                      <div class="row">
                                        <div class="col-xll-4 col-xl-4 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label
                                              :class="{'col-xl-12 col-form-label':true, 'text-danger': !!errors.name}"
                                              for="DirName"
                                            >
                                              {{ $t( 'Directory.table.Name' ) }}: <small>(*)</small>
                                            </label>
                                            <div class="col-xl-12">
                                              <input
                                                id="DirName"
                                                v-model="directory.name"
                                                type="text"
                                                :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.name}"
                                                :placeholder="$t( 'Directory.form.placeholder.name' )"
                                                @change="validateDirectory"
                                              >
                                              <p
                                                v-if="errors.name"
                                                class="text-danger font-weight-bolder my-1"
                                              >
                                                {{ errors.name }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-xll-4 col-xl- col-md-4 col-sm-12">
                                          <div class="row">
                                            <label
                                              :class="{'col-xl-12 col-form-label':true, 'text-danger': !!errors.email}"
                                              for="DirEmail"
                                            >
                                              {{ $t( 'Directory.form.Email' ) }}: <small>(*)</small>
                                            </label>
                                            <div class="col-xl-12">
                                              <input
                                                id="DirEmail"
                                                v-model="directory.email"
                                                type="email"
                                                :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.email}"
                                                :placeholder="$t( 'Directory.form.placeholder.email' )"
                                                @change="validateDirectory"
                                              >
                                              <p
                                                v-if="errors.email"
                                                class="text-danger font-weight-bolder my-1"
                                              >
                                                {{ errors.email }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-xll-4 col-xl-4 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label
                                              class="col-xl-12 col-form-label"
                                              for="DirURL"
                                            >
                                              {{ $t( 'Directory.form.URL' ) }}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input
                                                id="DirURL"
                                                v-model="directory.links.website"
                                                type="text"
                                                name="URL"
                                                :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.url}"
                                                :placeholder="$t( 'Directory.form.placeholder.website' )"
                                                @change="validateDirectory"
                                              >
                                              <p
                                                v-if="errors.url"
                                                class="text-danger font-weight-bolder my-1"
                                              >
                                                {{ errors.url }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-xll-3 col-xl-3 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label
                                              class="col-xl-12 col-form-label"
                                              for="DirPhone"
                                            >
                                              {{ $t( 'Property.Enquiries.Telephone' ) }}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input
                                                id="DirPhone"
                                                v-model="directory.phoneNumbers.primary"
                                                type="text"
                                                :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.phone}"
                                                :placeholder="$t( 'Directory.form.placeholder.phone' )"
                                                @change="validateDirectory"
                                              >
                                              <p
                                                v-if="errors.phone"
                                                class="text-danger font-weight-bolder my-1"
                                              >
                                                {{ errors.phone }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-xll-3 col-xl-3 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label
                                              class="col-xl-12 col-form-label"
                                              for="DirMobile"
                                            >
                                              {{ $t( 'Directory.table.Mobile' ) }}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input
                                                id="DirMobile"
                                                v-model="directory.phoneNumbers.mobile"
                                                type="text"
                                                :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.mobile}"
                                                :placeholder="$t( 'Directory.form.placeholder.mobile' )"
                                                @change="validateDirectory"
                                              >
                                              <p
                                                v-if="errors.mobile"
                                                class="text-danger font-weight-bolder my-1"
                                              >
                                                {{ errors.mobile }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-xll-3 col-xl-3 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label
                                              class="col-xl-12 col-form-label"
                                              for="DirWhatsApp"
                                            >
                                              {{ $t( 'Directory.form.WhatsApp' ) }}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input
                                                id="DirWhatsApp"
                                                v-model="directory.phoneNumbers.whatsapp"
                                                type="text"
                                                :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.whatsapp}"
                                                :placeholder="$t( 'Directory.form.placeholder.mobile' )"
                                                @change="validateDirectory"
                                              >
                                              <p
                                                v-if="errors.whatsapp"
                                                class="text-danger font-weight-bolder my-1"
                                              >
                                                {{ errors.whatsapp }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row mt-4">
                                        <div class="col-xll-12 col-xl-12 col-md-12 col-sm-12">
                                          <label :class="{'col-form-label':true, 'text-danger':!!errors.categories}">
                                            {{ $t(`Directory.form.Category`) }}: <small>(*)</small>
                                          </label>
                                          <ul class="ts-checktags d-block">
                                            <li
                                              v-for="category in subCategories"
                                              :key="category"
                                            >
                                              <input
                                                :id="'sub-cat-' + category"
                                                v-model="categories"
                                                type="checkbox"
                                                :value="category"
                                                :disabled="categories.length > 0 && !isAdminUser && !categories.includes( category )"
                                                @change="validateDirectory"
                                              >
                                              <label
                                                :for="'sub-cat-' + category"
                                                class="ts-checktags-label"
                                              >
                                                {{ $t(`Directory.subcategory.${category}`) }}
                                              </label>
                                            </li>
                                          </ul>
                                          <p
                                            v-if="errors.categories"
                                            class="text-danger font-weight-bolder my-1"
                                          >
                                            {{ errors.categories }}
                                          </p>
                                        </div>
                                      </div>
                                      <div class="m-separator--dashed m-separator mb-3 m-separator--md" />
                                      <div class="row">
                                        <div class="col-xll-12 col-xl-12 col-md-5 col-sm-12 col-xs-12">
                                          <div class="row">
                                            <div class="col-xll-3 col-xl-2 col-md-3 col-sm-12">
                                              <div class="row">
                                                <label
                                                  class="col-xl-12 col-form-label"
                                                  for="DirZipCode"
                                                >
                                                  {{ $t( 'Directory.table.ZipCode' ) }}:
                                                </label>
                                                <div class="col-xl-12">
                                                  <input
                                                    id="DirZipCode"
                                                    v-model="directory.zipCode"
                                                    type="text"
                                                    :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.postcode}"
                                                    :placeholder="$t( 'Directory.table.ZipCode' )"
                                                    @change="validateDirectory"
                                                  >
                                                  <p
                                                    v-if="errors.postcode"
                                                    class="text-danger font-weight-bolder my-1"
                                                  >
                                                    {{ errors.postcode }}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-xll-9 col-xl-10 col-md-9 col-sm-12">
                                              <div class="row">
                                                <label
                                                  class="col-xl-12 col-form-label"
                                                >
                                                  {{ $t( 'Directory.form.BusinessLocation' ) }}:
                                                </label>
                                                <div class="col-xl-12">
                                                  <div class="input-group">
                                                    <v-select
                                                      v-model="params.Location"
                                                      :filterable="false"
                                                      :options="suggestedLocations"
                                                      :placeholder="$t( 'common.Eg' ) + 'Denia, Alicante'"
                                                      class="custom-select form-control m-input--solid noclose"
                                                      @search="suggestLocations"
                                                    >
                                                      <template #selected-option="option">
                                                        {{ option.text[userLang] || option.text[ 'es' ] }}
                                                      </template>
                                                      <template #no-options>
                                                        <span v-if="suggestedLocationsText.length > 2">
                                                          {{ $t( 'common.NoMatchingLocations' ) }}
                                                        </span>
                                                        <span v-else />
                                                      </template>
                                                      <template
                                                        #option="option"
                                                        slot-scope="option"
                                                      >
                                                        <p
                                                          style="line-height: 22px;margin: 0px;padding:6px 0px 4px 6px;"
                                                          v-html="formatSuggestedLocation( option, suggestedLocationsText )"
                                                        />
                                                      </template>
                                                    </v-select>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-xll-12 col-xl-12 col-md-8 col-sm-12 col-xs-12">
                                          <div class=" row ">
                                            <label class="col-xl-12 col-form-label">
                                              {{ $t( 'Directory.form.Address' ) }}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input
                                                id="Address"
                                                v-model="directory.address"
                                                type="text"
                                                :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.address}"
                                                :placeholder="$t( 'Directory.form.Address' )"
                                                @change="validateDirectory"
                                              >
                                              <p
                                                v-if="errors.address"
                                                class="text-danger font-weight-bolder my-1"
                                              >
                                                {{ errors.address }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-xl-4 col-md-12 col-sm-12">
                                          <div class="row">
                                            <div class="col-xl-12">
                                              <div class="row">
                                                <label class="col-xl-12 col-form-label">
                                                  {{ $t( 'Directory.form.Coordinates.label' ) }}:
                                                </label>
                                                <div class="col-xl-6 col-sm-6">
                                                  <div class="input-group form-group">
                                                    <div class="input-group-prepend">
                                                      <span class="input-group-text">
                                                        <small>{{ $t( 'Directory.form.Coordinates.latitude.shortlabel' ) }}</small>
                                                      </span>
                                                    </div>
                                                    <input
                                                      v-model.number="directory.location.latitude"
                                                      :readonly="!positionEdition"
                                                      name="Latitude"
                                                      :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.latitude}"
                                                      :placeholder="$t( 'Directory.form.Coordinates.latitude.placeholder' )"
                                                      @change="validateDirectory"
                                                    >
                                                  </div>
                                                  <p
                                                    v-if="errors.latitude"
                                                    class="text-danger font-weight-bolder my-1"
                                                  >
                                                    {{ errors.latitude }}
                                                  </p>
                                                </div>
                                                <div class="col-xl-6 col-sm-6">
                                                  <div class="input-group form-group">
                                                    <div class="input-group-prepend">
                                                      <span class="input-group-text">
                                                        <small>{{ $t( 'Directory.form.Coordinates.longitude.shortlabel' ) }}</small>
                                                      </span>
                                                    </div>
                                                    <input
                                                      v-model.number="directory.location.longitude"
                                                      :readonly="!positionEdition"
                                                      name="Longitude"
                                                      :class="{'form-control m-input m-input--solid': true, 'border-danger': !!errors.longitude}"
                                                      :placeholder="$t( 'Directory.form.Coordinates.longitude.placeholder' )"
                                                      @change="validateDirectory"
                                                    >
                                                  </div>
                                                  <p
                                                    v-if="errors.longitude"
                                                    class="text-danger font-weight-bolder my-1"
                                                  >
                                                    {{ errors.longitude }}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-xl-12">
                                              <button
                                                type="button"
                                                class="btn btn-brand btn-sm mb-1 mr-1"
                                                :disabled="!directory.address"
                                                @click="getLatLngFromAddress"
                                              >
                                                <i class="la la-map-marker" /> {{ $t( 'Directory.form.useAddressBtn' ) }}
                                              </button>
                                              <button
                                                type="button"
                                                class="btn btn-brand btn-sm mb-1 mr-1"
                                                @click="getCurrentLocation($event)"
                                              >
                                                <i class="la la-map-marker" /> {{ $t( 'Directory.form.coordinateButtons.useMyLocation' ) }}
                                              </button>
                                              <button
                                                type="button"
                                                class="btn btn-brand btn-sm mb-1 mr-1"
                                                @click="toggleAddEdit"
                                              >
                                                <i class="la la-map-marker" /> {{ $t("Directory.form.coordinateButtons.addEdit") }}
                                              </button>
                                              <button
                                                type="button"
                                                class="btn btn-danger btn-sm mb-1"
                                                @click="clearCoord"
                                              >
                                                <i class="la la-map-marker" /> {{ $t( 'Directory.form.coordinateButtons.clear' ) }}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-xl col-md-12 col-sm-12">
                                          <label class="col-xl-12 col-form-label m--hidden-tablet-and-mobile" />
                                          <template v-if="directory.location.latitude && directory.location.longitude">
                                            <Suspense>
                                              <template #default>
                                                <Map
                                                  :center-latitude="directory.location.latitude"
                                                  :center-longitude="directory.location.longitude"
                                                  style="width: 100%; height: 300px"
                                                  @marker-dragend="positionMoved"
                                                >
                                                  >
                                                </Map>
                                              </template>
                                            </Suspense>
                                            <div class="col-xl-12 mt-2">
                                              <span class="m-form__help">
                                                <i class="la la-map-marker" /> {{ $t( 'Directory.form.map.helptext' ) }}
                                              </span>
                                            </div>
                                          </template>
                                          <template v-else>
                                            <div class="row">
                                              <div class="col-xl-12">
                                                <div class="col-xl-12 m-stack m-stack--ver m-stack--general px-0">
                                                  <div
                                                    class="col-xl-12 card text-center m-stack__item m-stack__item--center m-stack__item--middle"
                                                    style="height:300px"
                                                  >
                                                    <label class="col-xl-12 col-form-label m-stack__item m-stack__item--center m-stack__item--middle">
                                                      <i class="la la-map m--icon-font-size-lg2 d-block" /> {{ $t( 'Directory.form.map.helptext2' ) }}
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                id="m_wizard_form_step_2"
                                class="m-wizard__form-step"
                              >
                                <div
                                  class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-brand alert-dismissible fade show"
                                  role="alert"
                                >
                                  <div class="m-alert__icon">
                                    <i class="flaticon-exclamation-1" />
                                    <span />
                                  </div>
                                  <div class="m-alert__text">
                                    <strong>{{ $t( 'Property.form.Note' ) }}:</strong> {{ $t( 'Directory.SelectLanguages' ) }}
                                  </div>
                                </div>
                                <div
                                  v-if="directory.languages"
                                  class="row"
                                >
                                  <label class="col-xl-12 col-form-label">
                                    {{ $t( 'Directory.form.SpokenLanguages' ) }}:
                                  </label>
                                  <div
                                    v-for="(language, index) in languages"
                                    :key="index"
                                    class="col-6 col-lg-2 pt-xl-2 pt-lg-2 pt-md-2 pt-sm-2 pt-xs-2 pt-2"
                                  >
                                    <label class="m-checkbox m-checkbox--solid m-checkbox--brand">
                                      <input
                                        v-model="directory.languages"
                                        type="checkbox"
                                        :value="language.code"
                                        @change="validateDirectory"
                                      >
                                      {{ $t( 'language.' + language.code) }}
                                      <span />
                                    </label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xl-12">
                                    <div class="form-group row m-form__group">
                                      <div
                                        v-for="(language, index) in directory.languages.filter( l => allLanguages.includes( l ) )"
                                        :key="index"
                                        class="col-xl-12 mt-4"
                                      >
                                        <h3 class="m-portlet__head-text">
                                          {{ $t( 'language.' + language) }}
                                        </h3>
                                        <textarea
                                          v-model="directory.descriptions[language]"
                                          rows="10"
                                          :class="{'form-control m-input m-input--solid mb-2':true}"
                                          :placeholder="
                                            $t(
                                              'common.PleaseEnterADescriptionNoTranslate',
                                              {
                                                language: $t(
                                                  'language.' +
                                                    language
                                                ),
                                              }
                                            )
                                          "
                                          :name="language"
                                          @change="validateDirectory"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                id="m_wizard_form_step_3"
                                class="m-wizard__form-step"
                              >
                                <div
                                  class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-brand alert-dismissible fade show"
                                  role="alert"
                                >
                                  <div class="m-alert__icon">
                                    <i class="flaticon-exclamation-1" />
                                    <span />
                                  </div>
                                  <div class="m-alert__text">
                                    <strong>{{ $t( 'Directory.form.Note' ) }}:</strong> {{ $t( 'common.maxfilesize' ) }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xl-12">
                                    <div
                                      id="m_sortable_portlets"
                                      class="row ui-sortable"
                                    >
                                      <div class="col-lg">
                                        <div class="m-portlet  m-portlet--head-sm">
                                          <div class="m-portlet__head">
                                            <div class="m-portlet__head-caption">
                                              <div class="m-portlet__head-title">
                                                <span class="m-portlet__head-icon m--hide">
                                                  <i class="la la-gear" />
                                                </span>
                                                <h3 class="m-portlet__head-text">
                                                  <template v-if="directory.logo || selectedFileDataURL">
                                                    {{ $t( 'common.Preview' ) }}
                                                  </template>
                                                  <template v-else>
                                                    {{ $t( 'Directory.form.UploadLogo' ) }}
                                                  </template>
                                                </h3>
                                              </div>
                                            </div>
                                          </div>
                                          <form enctype="multipart/form-data">
                                            <div
                                              v-if="!directory.logo && !selectedFileDataURL"
                                              class="m-portlet__body"
                                            >
                                              <div class=" m-form__group">
                                                <div class="row">
                                                  <div class="col-lg-12">
                                                    <div class="custom-file">
                                                      <input
                                                        id="file"
                                                        type="file"
                                                        class="custom-file-input"
                                                        :model="directory.logo"
                                                        accept="image/*"
                                                        @change="onFileChange"
                                                      >
                                                      <label
                                                        class="custom-file-label"
                                                        for="file"
                                                        :data-label="$t( 'common.chooseFile' )"
                                                      >
                                                        {{ $t( 'common.chooseFile' ) }}
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              v-if="( directory.logo || selectedFileDataURL ) && cropperPreviewURL"
                                              class="m-portlet__foot m-portlet__foot--fit"
                                            >
                                              <div class="m-form__actions">
                                                <div class="logopreview">
                                                  <div class="inlinedirectorypreview">
                                                    <div class="inlinedirectorypreview__img">
                                                      <img :src="cropperPreviewURL">
                                                    </div>
                                                    <div class="inlinedirectorypreview__info">
                                                      <p class="inlinedirectorypreview__name mb-1 font-weight-bold">
                                                        {{ directory.name }}
                                                      </p>
                                                      <p
                                                        v-if="categories && categories.length > 0"
                                                        class="directorypreview__cat mb-0 font-weight-normal"
                                                      >
                                                        {{ $t( 'Directory.subcategory.' + categories[ 0 ] ) }}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>

                                                <hr>

                                                <div class="logopreview">
                                                  <div class="directorypreview p-4">
                                                    <div class="directorypreview__img">
                                                      <img :src="cropperPreviewURL">
                                                    </div>
                                                    <div class="directorypreview__info">
                                                      <p class="directorypreview__txt mb-1 font-weight-bold">
                                                        {{ directory.name }}
                                                      </p>
                                                      <p class="directorypreview__txt mb-0 font-weight-normal">
                                                        <span v-if="categories && categories.length > 0">{{ $t( 'Directory.subcategory.' + categories[ 0 ] ) }}<template v-if="params.Location">, </template></span>
                                                        <span v-if="params.Location">{{ params.Location.text[ userLang ] || params.Location.text[ 'es' ] }}</span>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>

                                                <button
                                                  type="button"
                                                  class="m-btn btn-block m-btn--hover-danger m-btn--pill btn btn-secondary ws-nowrap mt-4"
                                                  @click="deleteImage"
                                                >
                                                  <i class="la la-trash" /> {{ $t( 'common.Delete' ) }}
                                                </button>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                      <div class="col-lg-8">
                                        <div
                                          v-if="directory.logo || selectedFileDataURL"
                                          class="m-portlet m-portlet--mobile m-portlet--sortable m-portlet--head-sm photo-item"
                                        >
                                          <div class="m-portlet__head ui-sortable-handle text-overflow">
                                            <div class="m-portlet__head-caption">
                                              <div class="m-portlet__head-title">
                                                <span class="m-portlet__head-icon">
                                                  <i class="la la-photo m--font-brand" />
                                                </span>
                                                <h3
                                                  v-if="directory.logo"
                                                  class="m-portlet__head-text m--font-brand m--hidden-mobile m--hidden-tablet"
                                                >
                                                  {{ directory.logo }}
                                                </h3>
                                              </div>
                                            </div>
                                            <div class="m-portlet__head-tools">
                                              <div class="counter" />
                                            </div>
                                          </div>
                                          <div class="m-portlet__body">
                                            <p class="mb-1 font-weight-bold">
                                              {{ $t( 'common.AdjustImage' ) }}
                                            </p>
                                            <small><strong>{{ $t( 'common.Tip' ) }}: </strong>{{ $t( 'Directory.form.CropperHelp' ) }}</small>
                                            <div class="form-group mt-4">
                                              <label class="font-weight-bold">{{ $t( 'Directory.form.CropperBackgroundColour' ) }}:</label>
                                              <input
                                                v-model="cropperBg"
                                                type="color"
                                                class="mt-2 d-block"
                                                @change="updateBackgroundColour"
                                              >
                                            </div>
                                            <template v-if="seenStep3">
                                              <div
                                                id="cropper-container"
                                                class="mt-2"
                                                :style="`background-color:${cropperBg}`"
                                              >
                                                <template v-if="!directory.logoCropped">
                                                  <cropper
                                                    ref="cropper"
                                                    class="cropper"
                                                    :src="cropperSrc"
                                                    image-restriction="none"
                                                    :default-size="defaultSize"
                                                    :auto-zoom="false"
                                                    :canvas="cropperOps"
                                                    :min-width="100"
                                                    :min-height="50"
                                                    @change="onCropperChange"
                                                    @ready="onCropperReady"
                                                  />
                                                </template>
                                                <template v-else>
                                                  <cropper
                                                    ref="cropper"
                                                    class="cropper"
                                                    :src="cropperSrc"
                                                    image-restriction="none"
                                                    :default-position="defaultCroppedPosition"
                                                    :default-size="defaultCroppedSize"
                                                    :auto-zoom="false"
                                                    :canvas="cropperOps"
                                                    :min-width="100"
                                                    :min-height="50"
                                                    @change="onCropperChange"
                                                    @ready="onCropperReady"
                                                  />
                                                </template>
                                              </div>
                                            </template>
                                            <div class="btn-toolbar mt-4">
                                              <div class="btn-group">
                                                <button
                                                  type="button"
                                                  class="btn btn-secondary"
                                                  @click="zoomIn"
                                                >
                                                  {{ $t( 'Directory.form.CropperZoomIn' ) }}
                                                </button>
                                                <button
                                                  type="button"
                                                  class="btn btn-secondary"
                                                  @click="zoomOut"
                                                >
                                                  {{ $t( 'Directory.form.CropperZoomOut' ) }}
                                                </button>
                                              </div>
                                            </div>
                                            <button
                                              v-if="cropperReady && cropperChanged"
                                              type="button"
                                              class="btn btn-sm btn-outline-info mt-4"
                                              @click="resetCropper"
                                            >
                                              {{ $t( 'Directory.form.CropperReset') }}
                                            </button>
                                          </div>
                                        </div>
                                        <div
                                          v-else
                                          class="m-stack m-stack--ver m-stack--general"
                                        >
                                          <h4 class="m-stack__item m-stack__item--center m-stack__item--middle">
                                            <i class="la la-camera m--icon-font-size-lg5" />
                                            <span class="d-block">{{ $t( 'common.nologouploadedyet' ) }}</span>
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                id="m_wizard_form_step_4"
                                class="m-wizard__form-step"
                              >
                                <div class="row">
                                  <div class="col-xl-12">
                                    <div class="row">
                                      <div class="col-lg-4">
                                        <div class="m-form__section">
                                          <div class="m-form__heading">
                                            <h3 class="m-form__heading-title">
                                              {{ $t( 'common.Details' ) }}
                                              <a
                                                href="javascript:"
                                                @click="clickEditTab(1)"
                                              >
                                                <i class="la la-pencil" />
                                              </a>
                                            </h3>
                                          </div>
                                          <div class="form-group m-form__group row">
                                            <div class="col-lg-12">
                                              <ul class="m-nav">
                                                <li class="m-nav__item">
                                                  <label class="m--font-boldest">
                                                    <strong>{{ directory.name }}</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  v-if="directory.categories"
                                                  class="m-nav__item"
                                                >
                                                  <label class="m--font-boldest">
                                                    <strong>{{ categories.map( c => $t( 'Directory.subcategory.' + c ) ).join( ', ' ) }}</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  v-if="directory.phoneNumbers.primary !== null && directory.phoneNumbers.primary !== ''"
                                                  class="m-nav__item"
                                                >
                                                  <label class="m--font-boldest">
                                                    <strong><i class="la la-phone" /> {{ directory.phoneNumbers.primary }}</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  v-if="directory.phoneNumbers.mobile !== null && directory.phoneNumbers.mobile !== ''"
                                                  class="m-nav__item"
                                                >
                                                  <label class="m--font-boldest">
                                                    <strong><i class="la la-mobile" /> {{ directory.phoneNumbers.mobile }}</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  v-if="directory.phoneNumbers.whatsapp !== null && directory.phoneNumbers.whatsapp !== ''"
                                                  class="m-nav__item"
                                                >
                                                  <label class="m--font-boldest">
                                                    <strong><i class="la la-mobile" /> {{ directory.phoneNumbers.whatsapp }}</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  v-if="directory.links.website !== null && directory.links.website !== ''"
                                                  class="m-nav__item"
                                                >
                                                  <label class="m--font-boldest">
                                                    <strong><i class="la la-globe" /> {{ directory.links.website }}</strong>
                                                  </label>
                                                </li>
                                                <li
                                                  v-if="getAddress(directory).length > 0"
                                                  class="m-nav__item"
                                                >
                                                  <label class="m--font-boldest">
                                                    <strong>
                                                      <i class="la la-location-arrow" />
                                                      {{ getAddress(directory) }}
                                                    </strong>
                                                  </label>
                                                </li>
                                                <li
                                                  v-if="directory.location.latitude && directory.location.longitude"
                                                  class="m-nav__item"
                                                >
                                                  <label class="m--font-boldest">
                                                    <strong>
                                                      <i class="la la-map-marker" /> {{ directory.location.latitude }}, {{ directory.location.longitude }}
                                                    </strong>
                                                  </label>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-lg-2">
                                        <div class="row">
                                          <div class="m-form__section m-form__section--first col">
                                            <div class="m-form__heading">
                                              <h3 class="m-form__heading-title">
                                                {{ $t( 'Directory.form.Logo' ) }}
                                                <a
                                                  href="javascript:"
                                                  @click="clickEditTab(3)"
                                                >
                                                  <i class="la la-pencil" />
                                                </a>
                                              </h3>
                                            </div>
                                            <div class="form-group m-form__group row">
                                              <div
                                                v-if="!directory.logo && !selectedFileDataURL"
                                                class="col-xl col-lg-4 col-md-4 col-sm-6 col-xs-12 col mb-3"
                                              >
                                                <p class="font-weight-bold text-danger">
                                                  {{ $t( 'common.nologouploaded' ) }}
                                                </p>
                                              </div>
                                              <div
                                                v-else-if="cropperPreviewURL"
                                                class="pl-3 mb-3"
                                              >
                                                <div class="logopreview p-4">
                                                  <div class="directorypreview">
                                                    <div class="directorypreview__img">
                                                      <img :src="cropperPreviewURL">
                                                    </div>
                                                    <div class="directorypreview__info">
                                                      <p class="directorypreview__txt mb-1 font-weight-bold">
                                                        {{ directory.name }}
                                                      </p>
                                                      <p class="directorypreview__txt mb-0 font-weight-normal">
                                                        <span v-if="categories && categories.length > 0">{{ $t( 'Directory.subcategory.' + categories[ 0 ] ) }}<template v-if="params.Location">, </template></span>
                                                        <span v-if="params.Location">{{ params.Location.text[ userLang ] || params.Location.text[ 'es' ] }}</span>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col">
                                        <div class="col-lg m-separator m-separator--dashed m-separator--lg" />
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg-12">
                                        <div class="m-form__section m-form__section">
                                          <div class="m-form__heading">
                                            <h3 class="m-form__heading-title">
                                              {{ $t( 'Directory.form.AboutUs' ) }}
                                              <a
                                                href="javascript:"
                                                @click="clickEditTab(2)"
                                              >
                                                <i class="la la-pencil" />
                                              </a>
                                            </h3>
                                          </div>
                                          <div class="form-group m-form__group row pt-0">
                                            <div class="col-lg-12">
                                              <div class="m-portlet m-portlet--tabs m-portlet--unair m-portlet--head-sm mb-0">
                                                <div class="m-portlet__body pl-1 pt-3 pb-0">
                                                  <div class="row">
                                                    <div
                                                      v-for="language in directory.languages"
                                                      :key="language"
                                                      class="col-lg-6 col-12 col-md-12 col-xs-12 mb-4"
                                                    >
                                                      <h6 class="mb-4">
                                                        {{ $t( 'language.'+language) }}
                                                        <small>[{{ language }}]</small>
                                                      </h6>
                                                      <template v-if="directory.descriptions[language]">
                                                        <span v-html="directory.descriptions[language]" />
                                                      </template>
                                                      <template v-else>
                                                        <p
                                                          class="text-danger font-weight-bold"
                                                          v-html="$t( 'Directory.form.noDescFilledIn', { language: $t( 'language.'+language)} )"
                                                        />
                                                      </template>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="m-separator m-separator--dashed m-separator--lg" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                  <div class="d-inline-flex m-0">
                    <a
                      v-if="step > 1"
                      href="javascript:"
                      class="btn btn-secondary mr-2"
                      @click.prevent="clickEditTab(step-1)"
                    >
                      <span class="d-inline-flex align-items-center">
                        <i class="la la-arrow-left mr-1" />
                        <span>{{ $t( 'common.Back' ) }}</span>
                      </span>
                    </a>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      {{ $t( 'common.Cancel' ) }}
                    </button>
                  </div>
                  <div>
                    <button
                      v-if="step === 4"
                      type="button"
                      :class="{'btn m-0': true, 'btn-outline-primary': !directory.active, 'btn-primary': directory.active}"
                      data-wizard-action="submit"
                      :disabled="Object.keys(errors).length !== 0"
                      @click="confirmSaveDirectory(false)"
                    >
                      <span class="d-inline-flex align-items-center">
                        <span>{{ $t( 'common.save' ) }}</span>
                        <i class="la la-check ml-1" />
                      </span>
                    </button>
                    <button
                      v-if="step === 4 && !directory.active"
                      type="button"
                      class="btn btn-brand m-0"
                      data-wizard-action="submit"
                      :disabled="Object.keys(errors).length !== 0"
                      @click="confirmSaveDirectory(true)"
                    >
                      <span class="d-inline-flex align-items-center">
                        <span>{{ $t( 'common.SaveAndActvate' ) }}</span>
                        <i class="la la-check ml-1" />
                      </span>
                    </button>
                    <button
                      v-if="step !== 4"
                      type="button"
                      href="javascript:"
                      class="btn btn-warning m-0"
                      :disabled="stepHasErrors"
                      @click="clickEditTab(step+1)"
                    >
                      <span class="d-inline-flex align-items-center">
                        <span>{{ $t( 'common.Next' ) }}</span>
                        <i class="la la-arrow-right ml-1" />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>
<script>
import AppHeader from '../../common/Header.vue';
import AppFooter from '../../common/Footer.vue';
import LeftMenu from '../../common/menus/LeftMenu.vue';
import Map from '../../../Map.vue';
import vSelect from 'vue-select';
import Cookie from 'js-cookie';
import axios from 'axios';
import geoserviceapi from '../../../../api-clients/geo-serviceapi.js';
import { getAdmin, getUser, onBeforeOpenSwal } from '../../../../functions.ts';
import { byLocationType } from '../../../../common/locations';
import { businesslistingsapi } from '../../../../api-clients/business-listings-api.js';
import { Cropper } from 'vue-advanced-cropper';
import data from '../../../../data.js';
import 'vue-advanced-cropper/dist/style.css';
import { Loader } from '@googlemaps/js-api-loader';
import { transpileModule } from 'typescript';
import { hexToRgb, rgbToHex } from '../../../../common/color.js';

const ts = Date.now();

const directoryStub = {
    id: null,
    descriptions: {
        da: null,
        de: null,
        en: null,
        es: null,
        fi: null,
        fr: null,
        it: null,
        nl: null,
        no: null,
        pl: null,
        pt: null,
        ru: null,
        sv: null,
    },
    logo: '',
    logoCropped: null,
    location: {
        locationID: 0,
        latitude: null,
        longitude: null,
    },
    login: null,
    name: null,
    address: null,
    zipCode: null,
    links: {
        website: '',
    },
    phoneNumbers: {
        primary: null,
        mobile: null,
        whatsapp: null,
    },
    email: null,
    languages: [],
};

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
        vSelect,
        Cropper,
        Map,
    },
    beforeRouteLeave( to, from, next ) {
        this.closeModal();
        next();
    },
    data() {
        return {
            suggestedLocationsText: '',
            suggestedLocations: [],
            user: {},
            locationsMap: {},
            startTab: 1,
            loading: false,
            positionEdition: false,
            directories: [],
            params: {
                Location: null,
            },
            selectedCategory: '',
            categories: [],
            subCategories: [],
            selectedLocations: [],
            selectedFile: null,
            selectedFileDataURL: null,
            imgCrop: null,
            imgCropCoords: null,
            errors: {},
            errorKeys: [],
            directory: directoryStub,
            thinkspainURL: import.meta.env.TWC_TS_URL,
            validated: false,
            step: 1,
            languages: [],
            cropperReady: false,
            cropperChanged: false,
            seenStep1: true,
            seenStep2: false,
            seenStep3: false,
            seenStep4: false,
            directoryUnchanged: null,
            canvas: null,
            canvasDataURL: null,
            cropperBg: '#ffffff',
        };
    },
    computed: {
        allLanguages() {
            return data.languages().map( ( x ) => x.code );
        },
        stepHasErrors() {
            if ( this.step === 1 ) {
                return this.stepOneHasErrors;
            }
            if ( this.step === 2 ) {
                return this.stepTwoHasErrors;
            }
            if ( this.step === 3 ) {
                return this.stepThreeHasErrors;
            }
            return false;
        },
        stepOneHasErrors() {
            return [
                'name',
                'email',
                'address',
                'postcode',
                'phone',
                'mobile',
                'whatsapp',
                'url',
                'categories',
                'latitude',
                'longitude',
            ].some( ( k ) => this.errorKeys.includes( k ) );
        },
        stepTwoHasErrors() {
            return [
                'descriptions',
            ].some( ( k ) => this.errorKeys.includes( k ) );
        },
        stepThreeHasErrors() {
            return false;
        },
        userLang() {
            return Cookie.get( 'locale' );
        },
        cropperSrc() {
            if ( this.directory.logoCropped && this.directory.logoCropped.srcImgURL ) {
                return this.directory.logoCropped.srcImgURL + '?v=' + ts;
            } else if ( this.directory.logo && this.directory.logo.length > 0 ) {
                return this.directory.logo + '?v=' + ts;
            } else if ( this.selectedFileDataURL ) {
                return this.selectedFileDataURL;
            }
            return '';
        },
        cropperOps() {
            return {
                fillColor: this.cropperBg,
            };
        },
        cropperPreviewURL() {
            if ( !this.canvasDataURL ) {
                return null;
            }
            return this.canvasDataURL;
        },
        isAdminUser() {
            return !!getAdmin();
        },
    },
    async mounted() {
        let byName = function( c1, c2 ) {
            var name1 = c1.name.toUpperCase();
            var name2 = c2.name.toUpperCase();
            if ( name1 < name2 ) {
                return -1;
            }
            if ( name1 > name2 ) {
                return 1;
            }
            return 0;
        };

        let lang = this.userLang ? this.userLang : 'en';
        let listOfLanguages  = data.languages().map( ( language ) => {
            return { code: language.code,
                name: language.Labels[ lang ] };
        } ).sort( byName );
        this.languages = listOfLanguages;
        this.user = getUser();

        WizardForm.init();

        this.loadDirectories();
    },
    beforeUnmount() {
        this.closeModal();
    },
    methods: {
        updateBackgroundColour() {
            if ( !this.cropperReady ) {
                return;
            }

            document.querySelectorAll( '.vue-advanced-cropper__foreground' ).forEach( ( e ) => {
                e.style.background = this.cropperBg;
            } );

            const r =  this.$refs.cropper.getResult();

            if ( r.canvas ) {
                this.canvas = r.canvas;
                this.canvasDataURL = this.canvas.toDataURL();
            }
        },
        getLogoURL( d ) {
            let link = d.logo;

            if ( d.logoCropped && d.logoCropped.imgURL ) {
                link = d.logoCropped.imgURL;
            }

            const u = new URL( link );
            u.searchParams.set( 'v', Date.now() );
            return u.toString();
        },
        defaultCroppedPosition() {
            return {
                top: this.directory.logoCropped.crop.top,
                left: this.directory.logoCropped.crop.left,
            };
        },
        defaultPosition( o ) {
            return {
                left: o.imageSize.width / 2 - o.coordinates.width / 2,
                top: o.imageSize.height / 2 - o.coordinates.height / 2,
            };
        },
        defaultCroppedSize() {
            return {
                width: this.directory.logoCropped.crop.width,
                height: this.directory.logoCropped.crop.height,
            };
        },
        defaultSize( o ) {
            return {
                width: o.imageSize.width,
                height: o.imageSize.height,
            };
        },
        zoomIn() {
            if ( !this.$refs.cropper ) {
                return;
            }
            this.$refs.cropper.zoom( 1.1 );
        },
        zoomOut() {
            if ( !this.$refs.cropper ) {
                return;
            }
            this.$refs.cropper.zoom( 0.9 );
        },
        async activateDirectory( directory, promptUser = true ) {
            if ( promptUser ) {
                let confirm = await swal( {
                    title: this.$t( 'common.areyousure' ),
                    text: this.$t( 'Directory.form.ConfirmActivation' ),
                    showCancelButton: !0,
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                    confirmButtonText: this.$t( 'Directory.YesDoIt' ),
                    cancelButtonText: this.$t( 'common.Cancel' ),
                    type: 'warning',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );

                if ( !confirm.value ) {
                    return;
                }
            }

            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            const result = await businesslistingsapi.post( `/admin/listings/${directory.id}/activate` );

            if ( result.status !== 200 ) {
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );

                this.loading = false;
                mApp.unblock( 'body' );
                return;
            }

            this.loadDirectories();
            mApp.unblock( 'body' );
        },
        async deactivateDirectory( directory ) {
            let confirm = await swal( {
                title: this.$t( 'common.areyousure' ),
                text: this.$t( 'Directory.form.ConfirmDeActivation' ),
                showCancelButton: !0,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'Directory.YesDoIt' ),
                cancelButtonText: this.$t( 'common.Cancel' ),
                type: 'warning',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );

            if ( !confirm.value ) {
                return;
            }

            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            const result = await businesslistingsapi.post( `/admin/listings/${directory.id}/deactivate` );

            if ( result.status !== 200 ) {
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );

                this.loading = false;
                mApp.unblock( 'body' );
                return;
            }

            this.loadDirectories();
            mApp.unblock( 'body' );
        },
        resetEditor() {
            this.directory = null;
            this.directoryUnchanged = null;
            this.directory = JSON.parse( JSON.stringify( directoryStub ) );
            this.cropperReady = false;
            this.cropperChanged = false;
            this.cropperBg = '#ffffff';
            this.canvas = null;
            this.canvasDataURL = null;
            this.imgCrop = null;
            this.imgCropCoords = null;
            this.step = 1;
            this.seenStep2 = false;
            this.seenStep3 = false;
            this.seenStep4 = false;
            this.suggestedLocationsText = '';
            this.suggestedLocations = [];
            this.params.Location = null;
            this.selectedCategory = '';
            this.selectedLocations = [];
            this.selectedFile = null;
            this.selectedFileDataURL = null;
            this.errors = {};
            this.categories = [];
        },
        onCropperChange( { image, coordinates, canvas } ) {
            this.imgCrop = image;
            this.imgCropCoords = coordinates;
            this.cropperChanged = true;

            const r =  this.$refs.cropper.getResult();

            if ( r.canvas ) {
                this.canvas = r.canvas;
                this.canvasDataURL = this.canvas.toDataURL();
            }
        },
        resetCropper() {
            if ( this.directoryUnchanged && this.directoryUnchanged.logoCropped ) {
                this.imgCropCoords = this.directoryUnchanged.logoCropped.crop;
            } else {
                this.imgCropCoords = null;
            }

            this.$refs.cropper.reset();

            const r =  this.$refs.cropper.getResult();

            if ( r.canvas ) {
                this.canvas = r.canvas;
                this.canvasDataURL = this.canvas.toDataURL();
            }
        },
        onCropperReady() {
            this.cropperReady = true;
            this.updateBackgroundColour();
        },
        removeCategory( category ) {
            this.categories = this.categories.filter( ( c ) => c !== category );
        },
        onCategorySelect() {
            if ( this.categories.includes( this.selectedCategory ) ) {
                this.selectedCategory = '';
                return;
            }

            this.categories = [
                ...this.categories,
                this.selectedCategory,
            ];

            this.selectedCategory = '';
        },
        validateDirectory() {
            const directory = this.directory;

            const errors = {};

            if ( !directory.name || directory.name.length === 0 ) {
                errors.name = this.$t( 'Directory.errors.ErrInvalidName' );
            }

            if ( !directory.email || directory.email.length === 0 ) {
                errors.email = this.$t( 'Directory.errors.ErrInvalidEmail' );
            }

            if ( !this.categories || this.categories.length === 0 ) {
                errors.categories = this.$t( 'Directory.errors.ErrSelectCategory' );
            }

            if ( directory.links.website && directory.links.website.length > 0 ) {
                let link = directory.links.website;

                if ( !/^https:\/\//.test( link ) && !/^http:\/\//.test( link ) ) {
                    link = `https://${link}`;
                }

                try {
                    new URL( link );
                } catch ( e ) {
                    errors.url = this.$t( 'Directory.errors.ErrInvalidUrl' );
                }
            }

            if ( directory.phoneNumbers.primary ) {
                const phoneWithoutWhitespace = directory.phoneNumbers.primary.replaceAll( ' ', '' );

                if ( !/^[0-9()+]{8,}$/.test( phoneWithoutWhitespace ) ) {
                    errors.phone = this.$t( 'Directory.errors.ErrInvalidPhone' );
                }
            }

            if ( directory.phoneNumbers.mobile ) {
                const phoneWithoutWhitespace = directory.phoneNumbers.mobile.replaceAll( ' ', '' );

                if ( !/^[0-9()+]{8,}$/.test( phoneWithoutWhitespace ) ) {
                    errors.mobile = this.$t( 'Directory.errors.ErrInvalidPhone' );
                }
            }

            if ( directory.phoneNumbers.whatsapp ) {
                const phoneWithoutWhitespace = directory.phoneNumbers.whatsapp.replaceAll( ' ', '' );

                if ( !/^[0-9()+]{8,}$/.test( phoneWithoutWhitespace ) ) {
                    errors.whatsapp = this.$t( 'Directory.errors.ErrInvalidPhone' );
                }
            }

            if ( directory.location.latitude && ( directory.location.latitude > 90 || directory.location.latitude < -90 ) ) {
                errors.latitude = this.$t( 'Directory.errors.ErrInvalidLatitude' );
            }

            if ( directory.location.longitude && ( directory.location.longitude > 180 || directory.location.longitude < -180 ) ) {
                errors.latitude = this.$t( 'Directory.errors.ErrInvalidLongitude' );
            }

            this.errors = errors;

            this.errorKeys = Object.keys( this.errors );

            return Object.keys( errors ).length === 0;
        },
        createListing() {
            WizardForm.init();
            WizardForm.r.goFirst();
            $( '#modalDirectoryEdit' ).modal( 'show' );
        },
        formatSuggestedLocation( option, match ) {
            return `${this.highlightPartOfText( option.text[ this.userLang ], match )}<br><span><span style="font-size: 11px">${this.$t( 'Location.location-description-' + option.typeDescriptionKey )}</span>`;
        },
        isDirectoryOkForWebsite( directory ) {
            if ( !directory.name ) {
                return false;
            }
            return true;
        },
        highlightPartOfText( text, part ) {
            const position = text.toLowerCase().indexOf( part.toLowerCase() );

            if ( position < 0 ) {
                return text;
            }

            const before = text.substring( 0, position );
            const between = text.substring( position, position + part.length );
            const after = text.substring( position + part.length );

            const result = [ before, '<strong>', between, '</strong>', after ].join( '' );
            return result;
        },
        async suggestLocations( search, loading ) {
            this.suggestedLocationsText = search;

            if ( search.length <= 2 ) {
                this.suggestedLocations = [];
                return;
            }

            this.loading = true;
            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            const result = await geoserviceapi.get( '/locationwithtext', {
                params: {
                    query: search,
                    lang: this.$i18n.locale,
                    limit: 20,
                },
            } );

            if ( result.status === 200 ) {
                let locations = result.data || [];
                locations = locations.filter( ( l ) => [ 'municipality', 'district', 'neighbourhood', 'entity' ].includes( l.type ) );
                locations.sort( byLocationType );
                this.suggestedLocations = locations;
            }

            this.loading = false;
            mApp.unblock( 'body' );
        },
        toggleAddEdit() {
            this.positionEdition = !this.positionEdition;
        },
        getAddress( directory ) {
            if ( !this.params.Location ) {
                return ( directory.address || '' ) + ( directory.zipCode && directory.zipCode.length > 1 ? ', ' + directory.zipCode : '' );
            }

            return ( directory.address || '' ) + ( directory.zipCode && directory.zipCode.length > 1 ? ', ' + directory.zipCode : '' ) + ', ' + ( this.params.Location.text[ this.userLang ] || this.params.Location.text[ 'es' ] );
        },
        async loadDirectories() {
            this.directories = [];
            this.loading = true;
            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            const cats = new Promise( async ( resolve ) => {
                const catResult = await businesslistingsapi.get( '/subcategories' );

                if ( catResult.status !== 200 ) {
                    swal( {
                        title: this.$t( 'error.AnErrorOccurred' ),
                        type: 'error',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                }

                this.subCategories = catResult.data.filter( ( x ) => x.active ).map( ( x ) => x.name );
                resolve();
            } );

            const dirs = new Promise( async ( resolve ) => {
                const params = new URLSearchParams();
                params.set( 'take', 50 );
                params.set( 'agents', this.user.Login );
                params.set( 'includeInactive', true );

                let result = await businesslistingsapi.get( `/listings?${params.toString()}` );

                if ( result.status !== 200 ) {
                    swal( {
                        title: this.$t( 'error.AnErrorOccurred' ),
                        type: 'error',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                }

                if ( result.data && result.data.results ) {
                    this.directories = result.data.results;
                }

                resolve();
            } );

            await Promise.all( [
                cats,
                dirs,
            ] );

            let locationRequests = [];

            this.directories.forEach( async ( directory ) => {
                if ( !directory.location || !directory.location.locationID || !directory.location.locationID > 0 ) {
                    return;
                }

                const locationID = directory.location.locationID;

                locationRequests.push( new Promise( async ( resolve, reject ) => {
                    const result = await geoserviceapi.get( `/locations/${locationID}` );

                    if ( result.status !== 200 ) {
                        swal( {
                            title: this.$t( 'error.AnErrorOccurred' ),
                            type: 'error',
                            confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                            onBeforeOpen: () => {
                                onBeforeOpenSwal();
                            },
                        } );
                        reject();
                        return;
                    }

                    const location = result.data;

                    const textResult = await geoserviceapi.get( `/locations/${locationID}/text` );

                    if ( textResult.status !== 200 ) {
                        swal( {
                            title: this.$t( 'error.AnErrorOccurred' ),
                            type: 'error',
                            confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                            onBeforeOpen: () => {
                                onBeforeOpenSwal();
                            },
                        } );
                        reject();
                        return;
                    }

                    location.text = textResult.data;

                    this.locationsMap[ locationID ] = location;

                    resolve();
                } ) );
            } );

            await Promise.allSettled( locationRequests );

            mApp.unblock( 'body' );
            this.loading = false;
        },
        getRedirectURL( id ) {
            let baseURL = this.thinkspainURL;

            if ( this.userLang !== 'en' ) {
                baseURL += '/' + this.userLang;
            }

            return `${baseURL}/spain-listings/o${id}?preview=1`;
        },
        editDirectory( directory ) {
            this.resetEditor();

            WizardForm.init();
            WizardForm.r.goFirst();

            this.directory = JSON.parse( JSON.stringify( directory ) );

            this.directoryUnchanged = JSON.parse( JSON.stringify( directory ) );

            for ( let lang in this.directory.descriptions ) {
                this.directory.descriptions[ lang ] = this.directory.descriptions[ lang ].replace( /<br\s?\/?>/g, '\n' ).replace( /\n\s*\n\s*\n/g, '\n\n' );
            }

            if ( this.directory.location && this.directory.location.locationID && this.directory.location.locationID > 0 ) {
                this.params.Location = {
                    id: this.directory.location.locationID,
                    legacyID: this.locationsMap[ this.directory.location.locationID ].legacyID,
                    type: this.locationsMap[ this.directory.location.locationID ].type,
                    typeDescriptionKey: this.locationsMap[ this.directory.location.locationID ].typeDescriptionKey,
                    text: this.locationsMap[ this.directory.location.locationID ].text,
                };
            }

            if ( this.directory.categories ) {
                this.categories = this.directory.categories.filter( ( c ) => !!c.parent ).map( ( c ) => c.name );
            }

            if ( this.directory.logoCropped ) {
                this.imgCropCoords = {
                    top: this.directory.logoCropped.crop.top,
                    left: this.directory.logoCropped.crop.left,
                    width: this.directory.logoCropped.crop.width,
                    height: this.directory.logoCropped.crop.height,
                };

                if (  this.directory.logoCropped.crop.backgroundColour ) {
                    const bg = this.directory.logoCropped.crop.backgroundColour.split( ',' );

                    const r = parseInt( bg[ 0 ] );
                    const g = parseInt( bg[ 1 ] );
                    const b = parseInt( bg[ 2 ] );

                    this.cropperBg = rgbToHex( r, g, b );
                    this.updateBackgroundColour();
                }
            }

            this.validateDirectory();

            $( '#modalDirectoryEdit' ).modal( 'show' );
        },
        closeModal() {
            this.resetEditor();
            $( '#modalDirectoryEdit' ).modal( 'hide' );
        },
        async confirmSaveDirectory( activate = false ) {
            if ( this.directory.id && this.directory.id > 0 ) {
                await this.saveExisting();
            } else {
                await this.saveNew();
            }

            if ( activate && this.directories.length > 0 ) {
                await this.activateDirectory( this.directories[ 0 ], false );
            }
        },
        async saveNew() {
            mApp.block( '.modal-dialog', { message: 'Sending data. Please wait...' } );

            const result = await businesslistingsapi.post( '/admin/listings', this.getPayload() );

            if ( result.status !== 200 ) {
                let errorCode = result.data.code;

                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.server.' + errorCode ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );

                mApp.unblock( '.modal-dialog' );
                return;
            }

            const id = result.data.id;

            this.directory.id = id;

            if ( this.selectedFile !== null ) {
                await this.uploadFile();
                await this.saveExisting();
            }

            swal( {
                title: this.$t( 'Directory.DirectoryEdited.title' ),
                text: this.$t( 'Directory.DirectoryEdited.message' ),
                type: 'success',
                confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } ).then( () => {
                this.closeModal();
            } );

            await this.loadDirectories();

            mApp.unblock( '.modal-dialog' );
        },
        getPayload() {
            const directory = this.directory;

            const payload = {
                login: this.user.Login || '',
                name: directory.name || '',
                address: directory.address || '',
                postcode: directory.zipCode || '',
                latitude: directory.location.latitude,
                longitude: directory.location.longitude,
                emailAddress: directory.email || '',
                phoneNumbers: directory.phoneNumbers || {},
                links: {},
                descriptions: directory.descriptions || {},
                locations: [],
                categories: this.categories || [],
                languages: ( directory.languages || [] ).map( ( l ) => l.toLowerCase() ) || [],
                logo: directory.logo || '',
            };

            if ( Object.keys( directory.links || {} ).length > 0 ) {
                Object.keys( directory.links ).forEach( ( k ) => {
                    if ( directory.links[ k ] && directory.links[ k ].length > 0 ) {
                        payload.links[ k ] = directory.links[ k ];
                    }
                } );
            }

            if ( this.imgCropCoords ) {
                payload.imgCrop = {
                    ...this.imgCropCoords,
                };

                if ( this.cropperBg ) {
                    payload.imgCrop.backgroundColour = hexToRgb( this.cropperBg ).join( ',' );
                }
            }

            if ( this.params.Location && this.params.Location.id && this.params.Location.id > 0 ) {
                payload.locations = [ this.params.Location.id ];
            }

            return payload;
        },
        async saveExisting() {
            mApp.block( '.modal-dialog', { message: 'Sending data. Please wait...' } );

            const isValid = this.validateDirectory();

            if ( !isValid ) {
                mApp.unblock( '.modal-dialog' );
                return;
            }

            const result = await businesslistingsapi.put( `/admin/listings/${this.directory.id}`, this.getPayload() );

            if ( result.status !== 200 ) {
                const errorCode = result.data.code;

                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.server.' + errorCode ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );

                mApp.unblock( '.modal-dialog' );
                return;
            }

            swal( {
                title: this.$t( 'Directory.DirectoryEdited.title' ),
                text: this.$t( 'Directory.DirectoryEdited.message' ),
                type: 'success',
                confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );

            if ( this.selectedFile !== null ) {
                await this.uploadFile();
                await this.saveExisting();
            }

            this.closeModal();

            await this.loadDirectories();

            mApp.unblock( '.modal-dialog' );
        },
        clearCoord() {
            this.directory.location.latitude = null;
            this.directory.location.longitude = null;
        },
        async getLatLngFromAddress( event ) {
            mApp.block( event.target );

            const loader = new Loader( {
                apiKey: import.meta.env.TWC_GOOGLE_MAPS_KEY,
                version: 'weekly',
            } );

            const geocoderLib = await loader.importLibrary( 'geocoding' );

            const geocoder = new geocoderLib.Geocoder();

            const address = this.getAddress( this.directory );

            await geocoder.geocode( { 'address': address }, ( results, status ) => {
                mApp.unblock( event.target );
                if ( status !== 'OK' || results.length === 0 ) {
                    swal( {
                        title: this.$t( 'Dashboard.noresults' ),
                        text: this.$t( 'Directory.ThereWhereNoResultsFoundWithTheProvidedFullAddress' ),
                        type: 'error',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                }

                const result = results[ 0 ];

                this.directory.location.latitude = result.geometry.location.lat();
                this.directory.location.longitude = result.geometry.location.lng();
            } );
        },
        async positionMoved( marker ) {
            let confirm = await swal( {
                title: this.$t( 'common.areyousure' ),
                text: this.$t( 'Directory.YouAreAboutToChangeLatitudeAndLongitudeOfTheOutlet' ),
                showCancelButton: !0,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'Directory.YesDoIt' ),
                cancelButtonText: this.$t( 'common.Cancel' ),
                type: 'warning',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );

            if ( !confirm.value ) {
                return;
            }

            this.directory.location.latitude = marker.latLng.lat();
            this.directory.location.longitude = marker.latLng.lng();
        },
        getCurrentLocation( event ) {
            if ( !navigator.geolocation ) {
                return;
            }

            mApp.block( event.target );

            let component = this;

            let success = function( position ) {
                component.directory.location.latitude = position.coords.latitude;
                component.directory.location.longitude = position.coords.longitude;
            };

            let error = function() {
                swal( {
                    title: component.$t( 'Directory.MissingCoordenates' ),
                    text: component.$t( 'Directory.WeCouldntGeolcateYou' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
            };

            navigator.geolocation.getCurrentPosition( success, error );

            mApp.unblock( event.target );
        },
        // step3
        async deleteImage() {
            let confirm = await swal( {
                title: this.$t( 'common.areyousure' ),
                text: this.$t( 'Directory.logoWasDeletedSuccess.confirm' ),
                showCancelButton: !0,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'common.yesRemoveIt' ),
                cancelButtonText: this.$t( 'common.Cancel' ),
                type: 'warning',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );

            if ( !confirm.value ) {
                return;
            }

            this.selectedFile = null;
            this.selectedFileDataURL = null;
            this.imgCrop = null;
            this.imgCropCoords = null;

            this.directory.logo = '';
            this.directory.logoCropped = null;

            if ( this.$refs.cropper ) {
                this.$refs.cropper.refresh();
            }

            await swal( {
                title: this.$t( 'Directory.logoWasDeletedSuccess.title' ),
                text: this.$t( 'Directory.logoWasDeletedSuccess.message' ),
                type: 'success',
                confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );
        },
        async onFileChange( e ) {
            let files = e.target.files;

            // no files, nothing to do
            if ( files.length === 0 ) {
                return;
            }

            // just single file is to be uploaded anyway....
            let img = files[ 0 ];

            if ( ![ 'image/png', 'image/jpeg' ].includes( img.type ) ) {
                swal( {
                    title: this.$t( 'common.FormatNotAllowed' ),
                    text: this.$t( 'common.FormatNotAllowedImg' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            if ( img.size > 1024000 ) {
                swal( {
                    title: this.$t( 'common.sizeToBig' ),
                    text: this.$t( 'common.sizeToBigFile' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.selectedFile = img;

            const r = new FileReader();

            r.onload = () => {
                this.selectedFileDataURL = r.result;
                this.updateBackgroundColour();
            };

            r.readAsDataURL( img );

            if ( !this.directory.id ) {
                return; // can't upload right now
            }

            await this.uploadFile();
        },
        async uploadFile() {
            if ( !this.selectedFile || !this.directory.id ) {
                return;
            }

            const img = this.selectedFile;

            // getting pre-signed url
            const body = {
                'ContentType': img.type,
                'Size': img.size,
                'Name': img.name,
            };

            let presignedRequest = await businesslistingsapi.post( `/admin/listings/${this.directory.id}/upload`, body );
            if ( presignedRequest.status !== 200 ) {
                await swal( {
                    title: this.$t( 'error.ServerError400Image.title' ),
                    text: this.$t( 'error.ServerError400Image.text' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            let uploadFile = await axios.put( presignedRequest.data.FileUploadURL, img, { headers: { 'content-type': img.type,
                'x-amz-acl': 'public-read' } } );

            if ( uploadFile.status !== 200 ) {
                await swal( {
                    title: this.$t( 'error.ServerError400Image.title' ),
                    text: this.$t( 'error.ServerError400Image.text' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            let destFilePath = uploadFile = presignedRequest.data.FileUploadURL.split( '?' )[ 0 ];
            this.directory.logo = destFilePath;
            this.selectedFile = null;
        },
        clickEditTab( step ) {
            const valid = this.validateDirectory();

            if ( !valid ) {
                return;
            }

            this.step = step;

            WizardForm.r.goTo( step );

            if ( this.$refs.cropper && this.cropperReady && !this.seenStep3 ) {
                window.requestIdleCallback( () => {
                    this.$refs.cropper.refresh();
                } );
            }

            switch ( step ) {
            case 1:
                this.seenStep1 = true;
                break;
            case 2:
                this.seenStep2 = true;
                break;
            case 3:
                this.seenStep3 = true;
                break;
            case 4:
                this.seenStep4 = true;
                break;
            }
        },
    },
};
</script>
<style>
  #cropper-container {
    height: 300px;
    border: 1px solid red;
  }

  @media screen and (min-width: 768px) {
    width: 600px;
    height: 200px;
  }

  .cropper {
    width: 100%;
    height: 100%;
  }

  .vue-advanced-cropper__foreground {
    opacity: 1;
  }

  .vue-simple-handler {
    background-color: red;
  }

  .vue-simple-line {
    border-color: red;
  }

  .logopreview {
    background-color: #f1f1f1;
  }

  .directorypreview {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 100%;
  }

  @media screen and (min-width: 576px) {
      .directorypreview {
        width: 300px;
      }

      .directorypreview__img {
        width: 300px;
      }
  }

  .directorypreview__img {
    background-color: #fff;
    width: 100%;
    height: 125px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .directorypreview__img img {
    max-width: 100%;
    max-height: 100%;
  }

  .directorypreview__info {
    background-color: #4382ce;
    text-align: left;
    padding: 15px;
  }

  .directorypreview__txt {
    color: #fff;
  }

  .inlinedirectorypreview {
    padding: 10px 30px;
    height: 78px;
    width: 100%;
    display: flex;
  }

  .inlinedirectorypreview__img {
    max-width: 150px;
    max-height: 100%;
    margin-right: 8px;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .inlinedirectorypreview__img img {
    max-width: 150px;
    max-height: 50px;
  }

  .inlinedirectorypreview__info {
    flex: 1 1 auto;
    overflow: hidden;
  }

  .inlinedirectorypreview__name {
    font-size: 21px;
    color: #333;
    line-height: 25px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .directorypreview__cat {
    font-size: 14px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
